module.exports = __webpack_public_path__ + "img/05-full.c78fef2d.jpeg";